import { render } from "./AccountSettingAboutPrivacyIndex.vue?vue&type=template&id=070d95f6"
import script from "./AccountSettingAboutPrivacyIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingAboutPrivacyIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__